import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { getPercentageFull } from 'utils/metrics'
import { getTrialInformation } from 'ducks/apps/index'
import { getDefaultDatasource } from 'ducks/apps/datasources'
import { loadMetrics, getMetrics } from 'ducks/metrics'

import Icon from 'components/Shared/Icon'

import Tooltip from 'components/Shared/Tooltip'
import Button from '../Button'
import './TrialWarning.scss'

class TrialBanner extends Component {
  handleClick = () => {
    const { onClick } = this.props

    onClick()
  }

  getPercentageFull = () => {
    const { metrics, datasource } = this.props

    return getPercentageFull(metrics, datasource)
  }

  getText = () => {
    const percentage = this.getPercentageFull()

    if (percentage === null) {
      return percentage
    }

    return `${percentage} of free records used`
  }

  componentDidMount() {
    const { loadMetrics, datasource, appId } = this.props

    loadMetrics(appId, datasource.id)
  }

  render() {
    const { days, trialState } = this.props
    const text = this.getText()

    if (!text) {
      return null
    }

    const trialTooltip = (
      <>
        <h1 className="trial-tooltip-header">
          Integrations Pack Trial | {days} Left
        </h1>
        <p>
          Congrats! Your account is currently on a 14-day free trial of of the
          Integrations Pack.
        </p>
        <br />
        <h2 className="trial-tooltip-subheader">
          What are the benefits of the Integrations Pack?
        </h2>
        <ul>
          <li>
            <Icon type="check-circle" color="white" />
            Connect to external data sources with <b>External Collections</b>
          </li>
          <li>
            <Icon type="check-circle" color="white" />
            Run actions in external apps with <b>Custom Actions</b>
          </li>
          <li>
            <Icon type="check-circle" color="white" />
            Send & receive custom API requests with the <b>Collections API</b>
          </li>
        </ul>
        <br />
        <h2 className="trial-tooltip-subheader">What happens after 14 days?</h2>
        <p>
          Don't worry! You'll still be able to keep building your app and all of
          your integrations will be saved, they’ll just be paused until you
          upgrade your account.
        </p>
        <Button
          text
          to="https://help.adalo.com/integrations"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn More
        </Button>
      </>
    )

    const full = this.getPercentageFull() === '100%'

    return (
      <div className="trial-warning-button-wrapper">
        {trialState === 'during' ? (
          <Tooltip
            tooltip={trialTooltip}
            placement="top"
            hideArrow
            containerClassname="trial-tooltip-container"
          >
            <div className="integrations-trial-tooltip-wrapper">
              <p className="integrations-trial-wrapper">
                <i className="material-icons help-outline-icon">
                  compare_arrows
                </i>
                Integrations Pack Trial <b>| {days} Left</b>
              </p>
            </div>
          </Tooltip>
        ) : (
          <p>{text}</p>
        )}
        <Button
          small
          orange
          className={classNames(
            'trial-warning-button',
            full && 'trial-warning-button-full'
          )}
          onClick={this.handleClick}
        >
          Upgrade Now
        </Button>
      </div>
    )
  }
}

const mapStateToProps = (state, { appId }) => {
  const { days, trialState } = getTrialInformation(state, appId)

  return {
    metrics: getMetrics(state, appId),
    datasource: getDefaultDatasource(state, appId),
    days,
    trialState,
  }
}

export default connect(mapStateToProps, { loadMetrics })(TrialBanner)
